import React from 'react';
import AttendanceManagementView from './AttendanceManagementView';

const AttendanceManagementContainer = (props) => {
  return <AttendanceManagementView {...props} />;
};

export default AttendanceManagementContainer;
